import {
  getAllCoursesByInstitute,
  getChildCourses,
  getChildByInstitute,
  getMaterialByTopic,
  getCourses,
  getCourse,
  getAllCourses,
  deleteCourse,
  saveCourse,
  editCourse
} from './api'
import { courseSlice } from './reducer'

const {
  resetCourses,
  resetChapters,
  resetSubjects,
  resetTopics,
  resetError,
  setSelectedCourse,
  resetSelectedCourse
} = courseSlice.actions

export {
  getAllCoursesByInstitute,
  getChildCourses,
  resetCourses,
  resetChapters,
  resetSubjects,
  resetTopics,
  getChildByInstitute,
  getMaterialByTopic,
  getCourses,
  getCourse,
  getAllCourses,
  resetError,
  deleteCourse,
  setSelectedCourse,
  resetSelectedCourse,
  saveCourse,
  editCourse
}
